export default {
  pqb: '1.7em' // product quantity badge
};